import { render, staticRenderFns } from "./pcAbout.vue?vue&type=template&id=85ac6724&scoped=true&"
import script from "./pcAbout.vue?vue&type=script&lang=js&"
export * from "./pcAbout.vue?vue&type=script&lang=js&"
import style0 from "./pcAbout.vue?vue&type=style&index=0&id=85ac6724&lang=scss&scoped=true&"
import style1 from "./pcAbout.vue?vue&type=style&index=1&id=85ac6724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ac6724",
  null
  
)

export default component.exports